import { styled } from "@mui/styles";
import { OLTheme } from "contexts/Theme/ThemeProvider";
import React from "react";

const StyledLink = styled(`a`)(({ theme }: { theme: OLTheme }) => ({
  alignItems: "center",
  color: theme.primary500,
  display: "inline-flex",
  fontSize: 12,
  gap: theme.spacing(2),
  textDecoration: "none",
}));

type ExternalLinkProps = {
  className?: string;
  children: React.ReactNode;
  endIcon?: React.ReactNode;
  path: string;
  "data-test-id"?: string;
};

export function ExternalLink({
  className,
  children,
  endIcon,
  path,
  "data-test-id": dataTestId,
}: ExternalLinkProps) {
  return (
    <StyledLink
      className={className}
      href={path}
      target="_blank"
      data-test-id={dataTestId}
    >
      {children} {endIcon && endIcon}
    </StyledLink>
  );
}
